import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class Accordion {
  constructor (el) {
    this.el = el
    this.togglers = this.el.querySelectorAll('.js-accordion-toggler')
  }

  init () {
    this.initEvents()
    this.initDefaultState()
  }

  initEvents () {
    this.togglers.forEach(el => {
      el.addEventListener('click', e => this.toggle(e))
    });
  }

  toggle (e) {
    e.preventDefault()
    const container = e.currentTarget.closest('.js-accordion-item')
    const content = container.querySelector('.js-accordion-content')
    $(content).slideToggle(300).promise().done(function () {
      ScrollTrigger.refresh()
    })
    e.currentTarget.classList.toggle('active')
  }

  initDefaultState () {
    this.togglers.forEach(el => {
      const container = el.closest('.js-accordion-item')
      const content = container.querySelector('.js-accordion-content')
      el.classList.contains('active') ? content.style.display = 'block' : content.style.display = 'none'
    })
  }
}
